import React, { useEffect, useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { IHeaderParams } from '@ag-grid-community/all-modules';
import GridGroupHeaderCollapseExtandIcon from './GridGroupHeaderCollapseExtandIcon';
import GridGroupHeaderSortIcon from './GridGroupHeaderSortIcon';
import GridGroupHeaderMenuIcon from './GridGroupHeaderMenuIcon';
import './grid-group-header.scss';

const SORT_NEXT_CONFIGURATION: { [key: string]: string } = {
  none: 'asc',
  asc: 'desc',
  desc: '',
};

type Props = Partial<IHeaderParams>;

export default function GridGroupHeader({
  displayName,
  column,
  api,
  enableMenu,
  enableSorting,
  setSort,
  showColumnMenu,
}: Props): JSX.Element {
  const [allCollapsed, setAllCollapsed] = useState(true);
  const [sortOrder, setSortOrder] = useState('none');

  useEffect(() => {
    const sortChangedListener = () => setSortOrder(column?.getSort() ?? 'none');
    column?.addEventListener('sortChanged', sortChangedListener);
    return () => column?.removeEventListener('sortChanged', sortChangedListener);
  }, [column]);

  const handleClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (!enableSorting) {
      return;
    }

    const newSort = SORT_NEXT_CONFIGURATION[column?.getSort() ?? 'none'];
    setSort?.(newSort as ('asc' | 'desc'), event.shiftKey);
  };

  const handleExpandCollapseClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.stopPropagation();

    if (allCollapsed) {
      api?.expandAll();
      setAllCollapsed(false);

    } else {
      api?.collapseAll();
      setAllCollapsed(true);
    }
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.stopPropagation();
    showColumnMenu?.(event.currentTarget);
  };

  return (
    <div className="grid-group-header" onClick={handleClick} role="presentation">
      <div className="ag-header-cell-label">
        <GridGroupHeaderCollapseExtandIcon onClick={handleExpandCollapseClick} collapsed={allCollapsed} />
        <div className="ag-header-cell-label" role="presentation" unselectable="on">
          <span className="ag-header-cell-text" role="columnheader" unselectable="on">{displayName}</span>
          <GridGroupHeaderSortIcon sort={sortOrder} />
        </div>
      </div>
      {enableMenu && <GridGroupHeaderMenuIcon onClick={handleMenuClick} />}
    </div>
  );
}
